// ---
import React from 'react';
import AbstractReactComponent from "../AbstractReactComponent";
import classNames from 'classnames';

import "./PageWrapper.scss";

/**
 * Komponenta pro vlastní obsah stránky.
 * Komponenta podporuje sekce: leftPanel, rightPanel, které jsou předávány přes props, levý a pravý může být typu zasouvací.
 * Komponenta podporuje center panel, který je předáván jako children.
 */
class PageWrapper extends AbstractReactComponent {
    static propTypes = {
        leftPanel: React.PropTypes.oneOfType([    // pokud je uvedeno, obsahuje obsah levého panelu, pokud není uvedeno, levý panel se vůbec nezobrazí
            React.PropTypes.array,
            React.PropTypes.node
        ]),
        rightPanel: React.PropTypes.oneOfType([    // pokud je uvedeno, obsahuje obsah pravého panelu, pokud není uvedeno, pravý panel se vůbec nezobrazí
            React.PropTypes.array,
            React.PropTypes.node
        ]),
    };

    static defaultProps = {
    };

    render() {
        const {className, children, leftPanel, rightPanel} = this.props;

        const wrapperClassNames = classNames(
            className,
            "page-wrapper",
            {
                "has-left-panel": leftPanel ? true : false,
                "has-right-panel": rightPanel ? true : false,
            }
        );

        return (
            <div className={wrapperClassNames}>
                {leftPanel && <div className="page-wrapper-left-panel">
                    {leftPanel}
                </div>}
                <div className={"page-wrapper-center-panel"}>
                    {children}
                </div>
                {rightPanel && <div className="page-wrapper-right-panel">
                    {rightPanel}
                </div>}
            </div>
        )
    }
}

export default PageWrapper;
